export const ADD_ORDERS = 'ADD_ORDERS'
export const UPDATE_ORDERS = 'UPDATE_ORDERS'
export const DELETE_ORDERS = 'DELETE_ORDERS'
export const SELECT_ORDER = 'SELECT_ORDER'
export const PUSH_MESSAGE = 'PUSH_MESSAGE'
export const EMPTY_CHAT_HISTORY = 'EMPTY_CHAT_HISTORY'
export const EMPTY_ORDERS = 'EMPTY_ORDERS'
